import { render, staticRenderFns } from "./monProfileSociete.vue?vue&type=template&id=872532a0&style=background-color%3A%20%23eee%3B&"
import script from "./monProfileSociete.vue?vue&type=script&lang=js&"
export * from "./monProfileSociete.vue?vue&type=script&lang=js&"
import style0 from "./monProfileSociete.vue?vue&type=style&index=0&id=872532a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports